'use client';

import { useEffect, useRef } from 'react';
import { GridToolbarContainerProps } from '@mui/x-data-grid-premium';
import { useTable } from 'src/context/table';

interface ToolbarProps extends GridToolbarContainerProps {
  onExport?: (type: string) => void;
  onRemove?: () => void;
  headerSlots?: {
    slot1?: React.ReactNode;
    slot2?: React.ReactNode;
    slot3?: React.ReactNode;
    slot4?: React.ReactNode;
  };
}

interface ToolbarRowProps {
  children?: React.ReactNode;
  className?: string;
  borderBottom?: string;
}

const ToolbarRow = ({ children, className = '', borderBottom }: ToolbarRowProps) => (
  <div
    className={`w-full flex items-center p-4 ${className}`}
    style={borderBottom ? { borderBottom } : undefined}
  >
    {children}
  </div>
);

const TableToolbar = ({ ...props }: ToolbarProps) => {
  const secondaryHeaderRef = useRef<HTMLDivElement>(null);
  const { secondaryHeaderWidth, setSecondaryHeaderWidth } = useTable();

  useEffect(() => {
    if (!secondaryHeaderRef?.current) return;

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [secondaryHeaderRef]);

  function handleResize() {
    if (!secondaryHeaderRef?.current) return;
    setSecondaryHeaderWidth(secondaryHeaderRef.current.clientWidth);
  }

  const columns = !!props.headerSlots?.slot3;
  const secondRow = !!props.headerSlots?.slot2;
  return (
    <div
      className={`grid bg-white ${columns ? 'grid-cols-[2fr_1fr]' : 'grid-cols-1'}`}
      style={{
        borderBottom: secondRow ? '1px solid #d4d4d4' : 'none',
        height: secondRow ? '13rem' : 'auto',
      }}
    >
      <div className={`grid ${secondRow ? 'grid-rows-2' : 'grid-rows-1'}`}>
        {props.headerSlots?.slot1 && (
          <ToolbarRow borderBottom={'1px solid #d4d4d4'}>
            {props.headerSlots.slot1}
          </ToolbarRow>
        )}

        {props.headerSlots?.slot2 && (
          <ToolbarRow>{props.headerSlots.slot2}</ToolbarRow>
        )}
      </div>
      {(props.headerSlots?.slot3 || props.headerSlots?.slot4) && (
        <div
          ref={secondaryHeaderRef}
          className="grid grid-rows-2 bg-[#E5F3FB] w-full"
          style={{ minWidth: secondaryHeaderWidth }}
        >
          {props.headerSlots?.slot3 && (
            <ToolbarRow borderBottom={'1px solid #d4d4d4'}>
              {props.headerSlots?.slot3}
            </ToolbarRow>
          )}
          {props.headerSlots?.slot4 && (
            <ToolbarRow>{props.headerSlots.slot4}</ToolbarRow>
          )}
        </div>
      )}
    </div>
  );
};

export default TableToolbar;
